import React from "react";
import { ContentLayout } from "@cloudscape-design/components-themed/components";
const ContentLayoutWrapper = (props) => {
    const headerContainer = (props === null || props === void 0 ? void 0 : props.header) ? (React.createElement("div", { className: "layout-custom-header-class" },
        " ",
        props.header,
        " ")) : null;
    return (React.createElement("div", { className: "layout-custom-class" },
        React.createElement(ContentLayout, Object.assign({}, props, { header: headerContainer }), props.children)));
};
export default ContentLayoutWrapper;
